import React from "react";
import { withTranslation } from "react-i18next";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import { Input } from "components/bootstrap";
import { getValueFromInput } from "util/FormsUtils";
class ScriptNotificationForm extends React.Component {
  constructor() {
    super(...arguments);
    this.handleChange = (event) => {
      const { name } = event.target;
      this.propagateChange(name, getValueFromInput(event.target));
    };
    this.propagateChange = (key, value) => {
      const { config, onChange } = this.props;
      const nextConfig = cloneDeep(config);
      nextConfig[key] = value;
      onChange(nextConfig);
    };
  }
  render() {
    const { config, validation, t } = this.props;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "script-notification-v1-script_path",
        name: "script_path",
        label: t("script_notifications.script_path"),
        type: "text",
        bsStyle: validation.errors.script_path ? "error" : null,
        help: get(validation, "errors.script_path[0]", t("script_notifications.form.script_path_help")),
        value: config.script_path,
        onChange: this.handleChange,
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "script-notification-v1-script_args",
        name: "script_args",
        label: t("script_notifications.script_arguments"),
        type: "text",
        bsStyle: validation.errors.script_args ? "error" : null,
        help: get(validation, "errors.script_args[0]", t("script_notifications.form.script_args_help")),
        value: config.script_args,
        onChange: this.handleChange,
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "script-notification-v1-script_send_stdin",
        name: "script_send_stdin",
        label: t("script_notifications.send_stdin"),
        type: "checkbox",
        bsStyle: validation.errors.script_send_stdin ? "error" : null,
        help: get(validation, "errors.script_send_stdin[0]", t("script_notifications.form.send_stdin_help")),
        value: config.script_send_stdin,
        checked: !!config.script_send_stdin,
        onChange: this.handleChange
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "script-notification-v1-script_timeout",
        name: "script_timeout",
        label: t("script_notifications.script_timeout_milliseconds"),
        type: "text",
        bsStyle: validation.errors.script_timeout ? "error" : null,
        help: get(validation, "errors.script_timeout[0]", t("script_notifications.form.script_timeout_help")),
        value: config.script_timeout,
        onChange: this.handleChange,
        required: true
      }
    ));
  }
}
ScriptNotificationForm.defaultConfig = {
  script_path: "",
  script_args: (
    // eslint-disable-next-line no-template-curly-in-string
    "${event_definition_title} ${event_definition_type} ${event.timestamp} ${event.message} ${event.source}"
  ),
  script_send_stdin: false,
  script_timeout: 3e3
};
export default Object.assign(withTranslation("enterprise_integrations")(ScriptNotificationForm), {
  defaultConfig: ScriptNotificationForm.defaultConfig
});
